// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.fade-enter-active[data-v-f031eb82],\n.fade-leave-active[data-v-f031eb82] {\n  transition: opacity 300ms ease-in-out;\n  position: absolute;\n  width: 100%;\n}\n.fade-enter[data-v-f031eb82], .fade-leave-to[data-v-f031eb82] /* .fade-leave-active below version 2.1.8 */ {\n  opacity: 0;\n}\n", ""]);
// Exports
module.exports = exports;
